/** Parse stored phone into country code + up to 8-digit national number (LT-first). */
export function splitPhoneNumber(phoneRaw, fallbackCountry = '+370') {
  if (phoneRaw == null || phoneRaw === '') {
    return { countryCode: fallbackCountry || '+370', phone: '' };
  }
  const digits = String(phoneRaw).replace(/\D/g, '');
  if (!digits) {
    return { countryCode: fallbackCountry || '+370', phone: '' };
  }
  if (digits.length >= 11 && digits.startsWith('370')) {
    return { countryCode: '+370', phone: digits.slice(3, 11) };
  }
  // While typing, UI stores "+370" + national (e.g. "+3706" → digits "3706") — strip LT prefix
  if (digits.startsWith('370') && digits.length > 3 && digits.length < 11) {
    return { countryCode: '+370', phone: digits.slice(3) };
  }
  if (digits.length === 9 && digits.startsWith('86')) {
    return { countryCode: '+370', phone: digits.slice(2) };
  }
  if (digits.length === 9 && digits.startsWith('8')) {
    return { countryCode: '+370', phone: digits.slice(1) };
  }
  if (digits.length === 8) {
    return { countryCode: fallbackCountry || '+370', phone: digits };
  }
  if (digits.length > 8) {
    return {
      countryCode: fallbackCountry || '+370',
      phone: digits.slice(-8),
    };
  }
  return { countryCode: fallbackCountry || '+370', phone: digits };
}
